import { defineMessages } from 'react-intl';

const translations = {
  details: {
    title: {
      id: 'pages.transactionDetails.details.title',
      defaultMessage: 'Details',
      description: 'Title of the details section',
    },
    type: {
      id: 'pages.transactionDetails.details.type',
      defaultMessage: 'Type',
      description: 'Title of the type property in the details section',
    },
    reference: {
      id: 'pages.transactionDetails.details.reference',
      defaultMessage: 'Reference',
      description: 'Title of the reference property in the details section',
    },
    description: {
      id: 'pages.transactionDetails.details.description',
      defaultMessage: 'Description',
      description: 'Title of the reference property in the details section',
    },
    amountDue: {
      id: 'pages.transactionDetails.details.amountDue',
      defaultMessage: 'Amount due',
      description: 'Title of the amount due property in the details section',
    },
    amountPaid: {
      id: 'pages.transactionDetails.details.amountPaid',
      defaultMessage: 'Amount paid',
      description: 'Title of the amount paid property in the details section',
    },
    isPaid: {
      id: 'pages.transactionDetails.details.isPaid',
      defaultMessage: 'Paid',
      description: 'Title of the is paid property in the details section',
    },
    returnUrl: {
      id: 'pages.transactionDetails.details.returnUrl',
      defaultMessage: 'Return URL',
      description: 'Title of the return url property in the details section',
    },
    webhookUrl: {
      id: 'pages.transactionDetails.details.webhookUrl',
      defaultMessage: 'Webhook URL',
      description: 'Title of the webhook url property in the details section',
    },
    secret: {
      id: 'pages.transactionDetails.details.secret',
      defaultMessage: 'Secret',
      description: 'Title of the secret property in the details section',
    },
    paymentUrl: {
      id: 'pages.transactionDetails.details.paymentUrl',
      defaultMessage: 'Payment URL',
      description: 'Title of the payment url property in the details section',
    },
    client: {
      id: 'pages.transactionDetails.details.client',
      defaultMessage: 'Client',
      description: 'Title of the client property in the details section',
    },
    createdAt: {
      id: 'pages.transactionDetails.details.createdAt',
      defaultMessage: 'Created at',
      description: 'Title of the created at property in the details section',
    },
  },
  customer: {
    title: {
      id: 'pages.transactionDetails.customer.title',
      defaultMessage: 'Customer',
      description: 'Title of the customer section',
    },
  },
  payments: {
    title: {
      id: 'pages.transactionDetails.payments.title',
      defaultMessage: 'Payments',
      description: 'Title of the payments section',
    },
  },
};

export default defineMessages(translations);
